import { Compare } from '@coolblue-development/icons';
import { Button } from '@coolblue-development/freddy';

interface TransferButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

const TransferButton = ({ onClick, disabled }: TransferButtonProps): JSX.Element => {
  return (
    <Button
      startIcon={<Compare />}
      onClick={onClick}
      disabled={disabled}
      data-testid="transfer-button"
      variant="secondary"
    >
      Transfer
    </Button>
  );
};

export default TransferButton;
